<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Datenschutzerklärung</h3>
        <!--
        <h5 class="description list">
          AutoEdge 24 - Inhaber: Andreas Leibolt<br>
          Grüsener Str. 17a<br>
          35285 Gemünden<br>
          Telefon: +49 176 55980480<br>
          E-Mail: kontakt@autoedge24.de<br>
          Internet: www.autoedge24.de
        </h5>
        -->
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">1. Verantwortlicher</h4>
            <h5 class="description list">
              AutoEdge 24 - Inh. Andreas Leibolt<br>
              Grüsener Str. 17a<br>
              35285 Gemünden<br>
              Telefon: +49 176 55980480<br>
              E-Mail: kontakt@autoedge24.de
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">2. Erhebung und Speicherung personenbezogener Daten</h4>
            <h5 class="description list">
              Wir verarbeiten personenbezogene Daten (Name, Anschrift, Telefonnummer, E-Mail-Adresse, Zahlungsinformationen) ausschließlich zur Erfüllung und Abwicklung Ihrer Bestellung sowie zur Erfüllung gesetzlicher Pflichten.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">3. Weitergabe von Daten</h4>
            <h5 class="description list">
              Eine Weitergabe an Dritte erfolgt nur, soweit dies zur Vertragserfüllung notwendig ist (z. B. Versanddienstleister, Zahlungsanbieter) oder gesetzliche Vorschriften dies verlangen.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">4. Speicherdauer</h4>
            <h5 class="description list">
              Personenbezogene Daten werden nur so lange gespeichert, wie dies zur Erfüllung des Vertrags oder gesetzlicher Aufbewahrungspflichten erforderlich ist.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">5. Ihre Rechte</h4>
            <h5 class="description list">
              Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch gegen die Verarbeitung.<br>
              Zur Ausübung Ihrer Rechte können Sie uns jederzeit unter den angegebenen Kontaktdaten kontaktieren.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">6. Online-Streitbeilegung</h4>
            <h5 class="description list">
              Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung bereit: <a href="https://ec.europa.eu/consumers/odr">https://ec.europa.eu/consumers/odr</a>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">Hinweis zu Google Analytics</h4>
            <h5 class="description list">
              Sobald auf dieser Webseite Google Analytics, einen Webanalysedienst der Google Inc. ("Google"), verwendet wird, werden sog. "Cookies", Textdateien, auf Ihrem Computer gespeichert, die eine Analyse der Benutzung der Website durch Sie ermöglichen.<br>
              Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Im Falle der Aktivierung der IP-Anonymisierung auf dieser Webseite, wird Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber dem Websitebetreiber zu erbringen.<br>
              Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt. Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich werden nutzen können. Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das unter dem folgenden Link verfügbare Browser-Plugin herunterladen und installieren <a href="https://tools.google.com/dlpage/gaoptout?hl=de">https://tools.google.com/dlpage/gaoptout?hl=de</a>
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'privacy',
  bodyClass: 'privacy-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}
.page-header{
  background-color: white !important;
}
.page-header::before{
  background-color: white !important;
}
.description {
  font-weight: normal;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
